



















































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Genre, Playlist } from '@/types';
import UTable, { TableField } from '@/ui-lib/table/Table.vue';
import { preset } from '@/store/modules/preset';
import { convertTimeHHMMSS } from '@/utils/convertTimeHHMMSS';
import { RawLocation } from 'vue-router';
import { tag } from '@/store/modules/tag';

@Component<PlaylistTableList>({
  components: {
    UTable
  }
})
export default class PlaylistTableList extends Vue {
  @Prop({ required: true, type: Array })
  private list!: Playlist[];

  private get presets() {
    return preset.context(this.$store).state.list;
  }

  private get tags(): Genre[] {
    return tag.context(this.$store).state.list;
  }

  private get fields() {
    const res: TableField[] = [
      {
        name: 'id',
        label: 'ID',
        width: '65px',
        sortable: true
      },

      {
        name: 'image',
        label: '',
        width: '60px'
      },

      {
        name: 'title',
        label: 'Название'
      },

      {
        name: 'hasVocals',
        label: 'Вокал',
        width: '86px',
        filters: [
          { label: 'Неизвестно', value: 'null' },
          { label: 'С вокалом', value: 'true' },
          { label: 'Без вокала', value: 'false' }
        ]
      },

      {
        name: 'musicPresetIDs',
        label: 'Пресеты',
        width: '170px'
      },

      {
        name: 'tagIDs',
        label: 'Теги',
        width: '200px',
        filters: this.tags.map((t) => ({
          label: t.name,
          value: t.id.toString()
        })),
        filterWidth: '300px'
      },

      {
        name: 'totalTracks',
        label: 'Треки',
        align: 'right',
        width: '80px',
        sortable: true
      },

      {
        name: 'totalDuration',
        label: 'Длительность',
        align: 'right',
        width: '136px',
        sortable: true
      },

      {
        name: 'locationsCount',
        label: 'Используется',
        align: 'right',
        width: '144px',
        sortable: true
      }
    ];

    return res;
  }

  private presetsName(pl: Playlist) {
    return (
      this.presets
        .filter((g) => pl.musicPresetIDs.includes(g.id))
        .map((g) => g.name)
        .join(', ') || 'Неизвестно'
    );
  }

  private durationText(pl: Playlist) {
    return convertTimeHHMMSS(pl.totalDuration);
  }

  private itemRoute(pl: Playlist): RawLocation {
    return {
      name: 'playlistItem',
      params: {
        id: pl.id.toString()
      }
    };
  }

  private itemTracksRoute(pl: Playlist): RawLocation {
    return {
      name: 'playlistItemTracks',
      params: {
        id: pl.id.toString()
      }
    };
  }
}
